import FormatPrice from '@/elements/Product/Price/FormatPrice';

const SpecialPrice = ({price, currency = null, ...rest}) => {

    const {
        ...textRest
    } = rest ?? {};

    try {
        
        return (
            <FormatPrice 
                price={price} 
                currency={currency}
                variant={['h1', 'right']} 
                light={'red.600'}
                dark={'red.600'}
                {...textRest}
            />
        );

    } catch (e) {

        return <></>;

    }
}

export default SpecialPrice;